import AssignmentUI from "../_components/UI/AssignmentUI";
import AIFeedback from "../_pages/AIFeedback";
import Assignment from "../_pages/Assignment";
import ClassSummary from "../_pages/Class";
import Class from "../_pages/Class";
import EachStudentReport from "../_components/StudentReport/EachStudentReport";
import Home from "../_pages/Home";
import Overview from "../_pages/Overview";
import ReportHistory from "../_pages/ReportHistory";
import ReportHistoryDetails from "../_pages/ReportHistoryDetails";
import ReportExport from "../_pages/ReportExport";
import ReviewAccuracyTracking from "../_pages/ReviewAccuracyTracking";
import Review from "../_pages/Review";
import Settings from "../_pages/Settings";
import StaticContent from "../_pages/StaticContent";
import StudentReports from "../_pages/StudentReports";
import Students from "../_pages/Students";
import TeacherManagement from "../_pages/TeacherManagement";
import CMS from "../_pages/CMS";
import Eachcms from "../_pages/Eachcms";
import NotificationMng from "../_pages/NotificationMng";
import SchoolManagement from "../_pages/SchoolManagement";
import Teachers from "../_components/SchoolManagement/Teachers";
import Papers from "../_components/SchoolManagement/Papers";
import OurPlans from "../_pages/OurPlans";
import Help from "../_pages/Help";

import PlanManagement from "../_pages/PlanManagement";
import Subscription from "../_pages/Subscription";
import AddOn from "../_pages/AddOn";
import ManageAddOn from "../_pages/ManageAddOn";
import AIStudents from "../_components/AIFeedback/AIStudents";
import StudentReport from "../_components/StudentReport/StudentReportUI";


const status = localStorage?.getItem("ACCOUNT_STATUS");

const ProtectedRotues =
  status == 0 
    ? [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/student-list",
          element: <Students />,
        },
        {
            path: "/student-list/review-answers/:id",
          element: <Review />,
        },
        {
          path: "/static-content/:name",
          element: <StaticContent />,
        },
        // {
        //   path: "/ai-feedback",
        //   element: <AIFeedback />,
        // },
        {
          path: "/student-reports",
          element: <StudentReports />,
        },
        {
          path: "/student-reports/students/list",
          element: <EachStudentReport />,
        },
        {
          path: "/class",
          element: <ClassSummary />,
        },
        {
          path: "/report-history",
          element: <ReportHistory />,
        },
        {
          path: "/report-history/:grade/:subject/:exam/:file_name",
          element: <ReportHistoryDetails />,
        },
        {
          path: "/settings",
          element: <Settings />,
        },
        {
          path: "/our-plans",
          element: <OurPlans />,
        },
        {
          path: "/help",
          element: <Help />,
        },
        {
          path: "/addons",
          element: <AddOn />,
        },
        {
          path: "/ai-feedback",
          element: <AIFeedback />,
        },
        {
          path: "/ai-feedback/students",
          element: <AIStudents />,
        },
        {
          path: "/student-reports/students",
          element: <StudentReport />,
        }
       
      ]
    : [
        {
          path: "/",
          element: <Overview/>,
        },
        
        {
          path: "/overview",
          element: <Overview/>,
        },

        {
          path: "/teacher-management",
          element: <TeacherManagement />,
        },
        {
          path: "/assignments",
          element: <Assignment />,
        },
        {
          path: "/report-export",
          element: <ReportExport />,
        },
        {
          path: "/review-accuracy-tracking",
          element: <ReviewAccuracyTracking />,
        },
        {
          path: "/cms",
          element: <CMS />,
        },
        {
          path: "/cms/:name",
          element: <Eachcms />,
        },
        {
          path: "/cms/draft/:name",
          element: <Eachcms draft={true} />,
        },
        {
          path: "/notification-mng",
          element: <NotificationMng />,
        },
        {
          path: "/school-management",
          element: <SchoolManagement />,
        },
        {
          path: "/school-management/teachers",
          element: <Teachers />,
        },
        {
          path: "/school-management/teachers/papers",
          element: <Papers />,
        },
        {
          path: "/plan-management",
          element: <PlanManagement />,
        },
        {
          path: "/subscription",
          element: <Subscription />,
        },
        {
          path: "/manage-add-on",
          element: <ManageAddOn />,
        },
        
        
       
      ];

export default ProtectedRotues;
